module.exports = __webpack_public_path__ + "media/page-5.850ec85d.mp3";